import { render, staticRenderFns } from "./BxOrderModal__Style#Drawer.vue?vue&type=template&id=646e8454&scoped=true&"
import script from "./BxOrderModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./BxOrderModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./BxOrderModal__Style#Drawer.vue?vue&type=style&index=0&id=646e8454&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646e8454",
  null
  
)

export default component.exports